import type { BrandDTO } from "./client";
import { catalogApi } from "./client";

const BRAND_LOOKUP_PAGE_SIZE = 20;

export const brandLookupQueryKey = ["catalog", "brands", "lookup"] as const;

export async function brandLookupQueryFn(params: {
  search: string;
  pageParam: number;
}): Promise<{ items: BrandDTO[]; nextPage: number | null }> {
  const { search, pageParam } = params;
  const result = await catalogApi.listBrands({
    limit: BRAND_LOOKUP_PAGE_SIZE,
    offset: (pageParam - 1) * BRAND_LOOKUP_PAGE_SIZE,
    search: search.trim() || undefined,
  });
  const { data, meta } = result;
  const nextPage =
    meta.offset + data.length < meta.total ? pageParam + 1 : null;
  return { items: data, nextPage };
}

export async function brandPreloadQueryFn(
  id: string,
): Promise<BrandDTO | null> {
  if (!id) return null;
  return catalogApi.getBrand(id);
}

export function brandGetLabel(item: BrandDTO): string {
  return item.name;
}

export function brandGetValue(item: BrandDTO): string {
  return item.id;
}
